<template>
  <DefaultLayout>
    <div slot="content">
      <div class="d-flex align-center py-3">
        <div class="title" @click="updateOrganizations">Accounts</div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          hide-details
          class="mt-0 mr-3"
        ></v-text-field>
        <v-btn depressed color="primary" @click="addOrganization">Add new</v-btn>
      </div>
      <v-btn
        v-if="selectedAccounts.length > 0"
        class="mb-2"
        dark
        depressed
        color="orange"
        @click="setVerified"
        >Mark selected accounts as verified</v-btn
      >
      <v-data-table
        :headers="accountsHeaders"
        class="elevation-0"
        :loading="dataLoading"
        v-model="selectedAccounts"
        show-select
        :items="preparedOrganizations"
        :search="search"
        :footer-props="{
          itemsPerPageOptions: [20, 30, 50, { text: 'All', value: -1 }],
          showFirstLastPage: false,
          prevIcon: 'fal fa-chevron-left',
          nextIcon: 'fal fa-chevron-right',
          itemsPerPageText: 'Accounts per page'
        }"
        :hide-default-footer="preparedOrganizations.length < 11"
        :item-class="itemRowBackground"
      >
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            :itemsPerPageOptions="[20, 30, 50, { text: 'All', value: -1 }]"
            :showFirstLastPage="false"
            prevIcon="fal fa-chevron-left"
            nextIcon="fal fa-chevron-right"
            @update:options="updateOptions"
            items-per-page-text="Accounts per page"
          />
        </template>
        <template v-slot:item.dateCreated="{ item }">
          <span>{{ formatDate(item.dateCreated) }}</span>
        </template>
        <template v-slot:item.dateUpdated="{ item }">
          <span>{{ formatDate(item.dateUpdated) }}</span>
        </template>
        <template v-slot:item.adminFirstName="{ item }">
          <span>{{ item.adminFirstName }} {{ item.adminLastName }}</span>
        </template>
        <template v-slot:item.isTenantfunnel="{ item }">
          <template v-if="item.isTenantfunnel">
            <v-icon color="blue">fa-solid fa-check</v-icon>
          </template>
        </template>
        <template v-slot:item.isAIEnabled="{ item }">
          <template v-if="item.isAIEnabled">
            <v-icon color="blue">fa-solid fa-check</v-icon>
          </template>
        </template>
        <template v-slot:item.id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                :disabled="item.deletion"
                text
                icon
                color="blue"
                @click="editOrg(item)"
                ><v-icon>fa-solid fa-eye</v-icon></v-btn
              >
            </template>
            <span>View account</span>
          </v-tooltip>
          <v-tooltip bottom v-if="!item.deletion">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                :disabled="item.deletion"
                text
                icon
                color="red"
                @click="deleteAccount(item.id)"
                ><v-icon>fa-solid fa-close</v-icon></v-btn
              >
            </template>
            <span>Delete account</span>
          </v-tooltip>
          <v-tooltip bottom v-if="!item.deletion && item.status != 4">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                :disabled="item.deletion"
                text
                icon
                color="orange"
                @click="blockAccount(item.id)"
                ><v-icon>fa-solid fa-ban</v-icon></v-btn
              >
            </template>
            <span>Block account</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.status === 4">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                :disabled="item.deletion"
                text
                icon
                color="green"
                @click="unblockAccount(item.id)"
                ><v-icon>fa-solid fa-ban</v-icon></v-btn
              >
            </template>
            <span>Unblock account</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.deletion">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text icon color="green" @click="calcelDeleteAccount(item.id)"
                ><v-icon>fa-solid fa-close</v-icon></v-btn
              >
            </template>
            <span>Cancel delete account</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip small v-if="item.status === 0" color="gray" class="mr-1">None</v-chip>
          <v-chip small v-if="item.status === 1" dark color="blue" class="mr-1">Trial</v-chip>
          <v-chip small v-if="item.status === 2" dark color="orange" class="mr-1"
            >Pending Invoice</v-chip
          >
          <v-chip small v-if="item.status === 3" dark color="green" class="mr-1">Active</v-chip>
          <v-chip small v-if="item.status === 4" dark color="red" class="mr-1">Blocked</v-chip>
        </template>
        <template v-slot:item.verified="{ item }">
          <v-chip small v-if="item.verified" dark color="green" class="">Verified</v-chip>
          <v-chip small v-if="!item.verified" dark color="red" class="">Not Verified</v-chip>
        </template>
        <template v-slot:item.deletion="{ item }">
          <v-chip small v-if="!item.deletion" dark color="green" class="">No</v-chip>
          <v-chip small v-if="item.deletion" dark color="red" class="">Yes</v-chip>
        </template>
      </v-data-table>
      <!-- EDIT ACCOUNT DIALOG -->
      <v-dialog
        v-model="dialogAccount"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogAccount = false">
              <v-icon>fa-thin fa-circle-xmark</v-icon>
            </v-btn>
            <v-toolbar-title>{{ name + ' ' }}|{{ ' ' + modalTitle }}</v-toolbar-title>
          </v-toolbar>
          <v-list v-if="accountDetails" three-line subheader>
            <v-form ref="accountForm">
              <v-subheader>General settings</v-subheader>
              <v-list-item>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    :disabled="!editable"
                    dense
                    v-model="name"
                    :rules="rules"
                    label="Business Name"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    :disabled="!editable"
                    dense
                    v-model="email"
                    :rules="rules"
                    label="Business Email"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    :disabled="!editable"
                    dense
                    v-model="adminFName"
                    :rules="rules"
                    label="Admin First Name"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    :disabled="!editable"
                    dense
                    v-model="adminLName"
                    :rules="rules"
                    label="Admin Last Name"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    :disabled="!editable"
                    dense
                    v-model="adminEmail"
                    :rules="rules"
                    label="Admin Email"
                  ></v-text-field>
                </v-list-item-action>
                <v-checkbox
                  hide-details
                  :disabled="!editable"
                  class="account-form__checkbox pl-2 mt-0 mb-8 align-center"
                  color="blue"
                  v-model="isTenantFunnel"
                >
                  <template #append>
                    <p class="account-form__checkbox-text mb-0 grey--text text--darken-1">
                      Tenantfunnel Customer
                    </p>
                  </template>
                </v-checkbox>
                <v-checkbox
                  hide-details
                  :disabled="!editable"
                  class="account-form__checkbox pl-2 mt-0 mb-8 align-center"
                  color="blue"
                  v-model="isAIEnabled"
                >
                  <template #append>
                    <p class="account-form__checkbox-text mb-0 grey--text text--darken-1">
                      AI enabled
                    </p>
                  </template>
                </v-checkbox>
                <v-list-item-action class="mr-5">
                  <v-btn
                    v-if="!editable"
                    :loading="editableLoading"
                    icon
                    color="blue"
                    @click="editable = true"
                    ><v-icon>fa-light fa-pen-to-square</v-icon></v-btn
                  >
                  <v-btn v-if="editable" icon color="green" @click="saveAccountSetting()"
                    ><v-icon>fa-light fa-floppy-disk</v-icon></v-btn
                  >
                </v-list-item-action>
                <v-spacer></v-spacer>
                <v-list-item-action class="mt-1 mr-0">
                  <v-chip dark color="grey lighten" class="ma-2"
                    >Date created: {{ formatDate(accountDetails.account.dateCreated) }}</v-chip
                  >
                </v-list-item-action>
                <v-list-item-action class="mt-1 mr-0">
                  <v-chip dark color="grey lighten" class="ma-2"
                    >Date updated: {{ formatDate(accountDetails.account.dateUpdated) }}</v-chip
                  >
                </v-list-item-action>
                <v-list-item-action class="mt-1 mr-0">
                  <v-chip
                    v-if="!accountDetails.account.deletion"
                    dark
                    color="grey lighten"
                    class="ma-2"
                    >Deletion: NO</v-chip
                  >
                  <v-chip v-if="accountDetails.account.deletion" dark color="red" class="ma-2"
                    >Deletion: YES</v-chip
                  >
                </v-list-item-action>
                <v-list-item-action class="mt-1 ml-0">
                  <v-chip v-if="accountDetails.account.status === 0" color="gray" class="ma-2"
                    >Account status: None. Subscription not activated.</v-chip
                  >
                  <v-chip v-if="accountDetails.account.status === 1" dark color="blue" class="ma-2"
                    >Account status: Trial. Subscription activated.</v-chip
                  >
                  <v-chip
                    v-if="accountDetails.account.status === 2"
                    dark
                    color="orange"
                    class="ma-2"
                    >Account status: PendingInvoice. Subscription activated.</v-chip
                  >
                  <v-chip v-if="accountDetails.account.status === 3" dark color="green" class="ma-2"
                    >Account status: Active. Subscription activated.</v-chip
                  >
                  <v-chip v-if="accountDetails.account.status === 4" dark color="red" class="ma-2"
                    >Account status: Blocked. Subscription not activated.</v-chip
                  >
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-subheader>Subscription settings</v-subheader>
              <v-list-item>
                <v-list-item-action class="mr-5">
                  <v-select
                    :disabled="!editableSubscription"
                    dense
                    v-model="subscriptionPlansSelected"
                    :items="subscriptionPlans"
                    item-text="name"
                    item-value="id"
                    label="Subscription plan"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-select
                    :disabled="!editableSubscription"
                    dense
                    v-model="billingPeriodSelected"
                    :items="billingPeriod"
                    item-text="text"
                    item-value="value"
                    label="Billing period"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-select
                    :disabled="!editableSubscription"
                    dense
                    v-model="invoiceIssueTypeSelected"
                    :items="invoiceIssueType"
                    item-text="text"
                    item-value="value"
                    label="Invoice issue type"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-select
                    :disabled="!editableSubscription"
                    dense
                    v-model="invoiceTypeSelected"
                    :items="invoiceType"
                    item-text="text"
                    item-value="value"
                    label="Invoice type"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action v-if="editableSubscription" class="mr-5">
                  <v-text-field
                    :disabled="!editableSubscription"
                    dense
                    v-model="invoiceIssueAfterDays"
                    :rules="rules"
                    label="Invoice issue after days"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-btn
                    v-if="!editableSubscription"
                    :loading="editableSubscriptionLoading"
                    icon
                    color="blue"
                    @click="editableSubscription = true"
                    ><v-icon>fa-light fa-pen-to-square</v-icon></v-btn
                  >
                  <v-btn
                    v-if="editableSubscription"
                    icon
                    color="green"
                    @click="updateSubscription()"
                    ><v-icon>fa-light fa-floppy-disk</v-icon></v-btn
                  >
                </v-list-item-action>
                <v-spacer></v-spacer>
                <v-list-item-action class="mt-1 mr-0">
                  <v-chip dark color="grey lighten" class="ma-2"
                    >Date created: {{ formatDate(accountDetails.subscription.dateCreated) }}</v-chip
                  >
                </v-list-item-action>
                <v-list-item-action class="mt-1 mr-0">
                  <v-chip dark color="grey lighten" class="ma-2"
                    >Date updated: {{ formatDate(accountDetails.subscription.dateUpdated) }}</v-chip
                  >
                </v-list-item-action>
                <v-list-item-action class="mt-1 mr-0">
                  <v-chip dark color="grey lighten" class="ma-2"
                    >Next invoice:
                    {{ formatDate(accountDetails.subscription.nextInvoiceIssueDate) }}</v-chip
                  >
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <!-- <v-subheader>Subscription enabled features</v-subheader>
              <v-list-item>
              <v-row class="align-top pt-2 pb-4">
                <v-col v-for="f in accountDetails.subscriptionPlan.features" :key="f.feature" cols="2" sm="auto" class="px-0 py-0">
                  <v-list-item-action class="mt-0 mr-0 mb-0">
                    <v-chip small label v-if="f.enabled && f.feature != 0" dark color="green lighten" class="ma-2">{{ getFeatureName(f.feature) }}: YES</v-chip>
                    <v-chip small label v-if="!f.enabled && f.feature != 0" dark color="orange lighten" class="ma-2">{{ getFeatureName(f.feature) }}: NO</v-chip>
                  </v-list-item-action>
                </v-col>
              </v-row>
              </v-list-item>
              <v-divider></v-divider> -->
              <v-subheader>Subscription limits</v-subheader>
              <v-list-item class="mb-3">
                <v-list-item
                  v-for="f in accountDetails.subscription.quotaUsages"
                  :key="f.feature"
                  class="mr-5 elevation-1"
                  v-if="getLimitName(f.feature)"
                  style="cursor: pointer"
                  @click="resetUsage(f)"
                >
                  <v-subheader
                    >Name: {{ getLimitName(f.feature) }} <br />
                    Available: {{ f.available }}</v-subheader
                  >
                </v-list-item>
              </v-list-item>
              <v-divider></v-divider>
              <v-subheader
                >Invoices
                <v-btn
                  v-if="
                    accountDetails.subscription.billingPeriod === 1 &&
                    accountDetails.subscription.invoiceIssueType === 1 &&
                    accountDetails.subscription.invoiceType === 1
                  "
                  icon
                  color="green"
                  @click="createInvoice()"
                  ><v-icon>fa-solid fa-file-plus</v-icon></v-btn
                ></v-subheader
              >
              <v-list-item>
                <v-simple-table v-if="selectedInvoices">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">invoiceType</th>
                        <th class="text-left">€</th>
                        <th class="text-left">dateCreated</th>
                        <th class="text-left">dateExpired</th>
                        <th class="text-left">invoiceId</th>
                        <th class="text-left">status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in selectedInvoices" :key="item.id">
                        <td v-if="item.invoiceType === 1">
                          <v-chip dark small color="gray">Manual</v-chip>
                        </td>
                        <td v-if="item.invoiceType === 2">
                          <v-chip dark small color="gray">Stripe</v-chip>
                        </td>
                        <td>{{ item.cost }}.00</td>
                        <td>{{ formatDate(item.dateCreated) }}</td>
                        <td>{{ formatDate(item.dateExpired) }}</td>
                        <td>{{ item.invoiceId }}</td>
                        <td v-if="item.status === 1">
                          <v-chip dark small color="blue">New</v-chip
                          ><v-btn
                            v-if="item.invoiceType === 1"
                            class="ml-2"
                            icon
                            color="green"
                            @click="markInvoiceAsPaid(item)"
                            ><v-icon>fa-solid fa-thumbs-up</v-icon></v-btn
                          >
                        </td>
                        <td v-if="item.status === 2">
                          <v-chip dark small color="orange">Pending</v-chip>
                        </td>
                        <td v-if="item.status === 3">
                          <v-chip dark small color="green">Paid</v-chip>
                        </td>
                        <td v-if="item.status === 4">
                          <v-chip dark small color="red">Failed</v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-list-item>
            </v-form>
          </v-list>
          <!-- <v-card-text>
            <v-form ref="accountForm" class="mx-3 my-3">
              <v-text-field v-model="name" label="Business Name" type="text" ref="name" :rules="[v => !!v || '']" hide-details></v-text-field>
              <v-text-field v-model="email" label="Business Email" type="email" ref="email" :rules="[v => !!v || '']" hide-details></v-text-field>
              <v-row>
                <v-col cols="12" sm="6" class="py-0"><v-text-field v-model="adminFName" label="Admin First Name" type="text" ref="adminFName" :rules="[v => !!v || '']" hide-details></v-text-field></v-col>
                <v-col cols="12" sm="6" class="py-0"><v-text-field v-model="adminLName" label="Admin Last Name" type="text" ref="adminLName" :rules="[v => !!v || '']" hide-details></v-text-field></v-col>
              </v-row>
              <v-text-field v-model="adminEmail" label="Admin Email" type="email" ref="adminEmail" :rules="[v => !!v || '']" hide-details></v-text-field>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-select :items="discounts" class="mr-1" item-text="text" item-value="id" v-model="discount" label="Discount" hide-details></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-menu ref="discountDateMenu" :close-on-content-click="false" v-model="discountDateMenu" :return-value.sync="discountDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" v-model="discountDate" label="Discount Expire" readonly hide-details></v-text-field>
                    </template>
                    <v-date-picker v-model="discountDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn small tile text @click="discountDateMenu = false">Cancel</v-btn>
                      <v-btn small tile dark depressed color="blue" @click="$refs.discountDateMenu.save(discountDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-col class="py-0 px-0"><v-text-field v-model="requestQuote" label="Open requests quote limit" type="numeric" ref="requestQuote" :rules="[v => !!v || '']" hide-details></v-text-field></v-col>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-col class="py-0 px-0"><v-text-field v-model="maxAccounts" label="Max teams per account limit" type="numeric" ref="maxAccounts" :rules="[v => !!v || '']" hide-details></v-text-field></v-col>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-col class="py-0 px-0"><v-text-field v-model="maxUsers" label="Max users per team limit" type="numeric" ref="maxUsers" :rules="[v => !!v || '']" hide-details></v-text-field></v-col>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field class="mr-1" :disabled="isEdit" required v-model="credits" label="Credits" ref="credits" hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-menu ref="crExpireDateMenu" :disabled="isEdit" :close-on-content-click="false" v-model="crExpireDateMenu" :return-value.sync="creditsDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" :disabled="isEdit" v-model="creditsDate" label="Credits Expire" readonly hide-details></v-text-field>
                    </template>
                    <v-date-picker v-model="creditsDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn small tile text @click="crExpireDateMenu = false">Cancel</v-btn>
                      <v-btn small tile dark depressed color="blue" @click="$refs.crExpireDateMenu.save(creditsDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-menu ref="trialDateMenu" :close-on-content-click="false" v-model="trialDateMenu" :return-value.sync="trialDate" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" v-model="trialDate" label="Trial Expire" readonly hide-details></v-text-field>
                </template>
                <v-date-picker v-model="trialDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn small tile text @click="trialDateMenu = false">Cancel</v-btn>
                  <v-btn small tile dark depressed color="blue" @click="$refs.trialDateMenu.save(trialDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-0"><v-switch label="CSV Export" v-model="csv" hide-details></v-switch></v-col>
                <v-col cols="12" sm="6" md="4" class="py-0"><v-switch label="Verification Service" v-model="verificationServ" hide-details></v-switch></v-col>
                <v-col cols="12" sm="6" md="4" class="py-0"><v-switch label="Request Schedule" v-model="reqSched" hide-details></v-switch></v-col>
                <v-col cols="12" sm="6" md="4" class="py-0"><v-switch label="Guest Requests" v-model="anonReq" hide-details></v-switch></v-col>
                <v-col cols="12" sm="6" md="4" class="py-0"><v-switch label="QuickLinks" v-model="quickLinks" hide-details></v-switch></v-col>
                <v-col cols="12" sm="6" md="4" class="py-0"><v-switch label="Purged Requests" v-model="purgedRequests" hide-details></v-switch></v-col>
              </v-row>
            </v-form>
          </v-card-text> -->

          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="dialogAccount = false">Close</v-btn>
            <v-btn tile dark depressed color="blue" @click="saveOrganization">Save</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-dialog>
      <!-- EDIT ACCOUNT DIALOG -->
      <!-- ADD ACCOUNT DIALOG -->
      <v-dialog v-model="addDialogAccount" width="900">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="addDialogAccount = false">
              <v-icon>fa-thin fa-circle-xmark</v-icon>
            </v-btn>
            <v-toolbar-title>Add new account</v-toolbar-title>
          </v-toolbar>
          <v-list three-line subheader>
            <v-form ref="accountAddForm">
              <v-subheader>General settings</v-subheader>
              <v-list-item>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    dense
                    v-model="name"
                    :rules="rules"
                    label="Business Name"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    dense
                    v-model="email"
                    :rules="rules"
                    label="Business Email"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    dense
                    v-model="adminFName"
                    :rules="rules"
                    label="Admin First Name"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    dense
                    v-model="adminLName"
                    :rules="rules"
                    label="Admin Last Name"
                  ></v-text-field>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    dense
                    v-model="adminEmail"
                    :rules="rules"
                    label="Admin Email"
                  ></v-text-field>
                </v-list-item-action>
              </v-list-item>
              <v-subheader>Subscription settings</v-subheader>
              <v-list-item>
                <v-list-item-action class="mr-5">
                  <v-select
                    dense
                    v-model="subscriptionPlansSelected"
                    :items="subscriptionPlans"
                    item-text="name"
                    item-value="id"
                    label="Subscription plan"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-select
                    dense
                    v-model="billingPeriodSelected"
                    :items="billingPeriod"
                    item-text="text"
                    item-value="value"
                    label="Billing period"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-select
                    dense
                    v-model="invoiceIssueTypeSelected"
                    :items="invoiceIssueType"
                    item-text="text"
                    item-value="value"
                    label="Invoice issue type"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-select
                    dense
                    v-model="invoiceTypeSelected"
                    :items="invoiceType"
                    item-text="text"
                    item-value="value"
                    label="Invoice type"
                  ></v-select>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-text-field
                    dense
                    v-model="invoiceIssueAfterDays"
                    :rules="rules"
                    label="Invoice issue after days"
                  ></v-text-field>
                </v-list-item-action>
              </v-list-item>
            </v-form>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="addDialogAccount = false">Close</v-btn>
            <v-btn tile dark color="blue" @click="addNewAccount">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ADD ACCOUNT DIALOG -->
    </div>
  </DefaultLayout>
</template>

<script>
import uuidv4 from 'uuid/v4';
import {
  GET_SUBSCRIPTION_PLANS,
  GET_ACCOUNT_DETAILS,
  GET_ORGANIZATIONS,
  ADD_ORGANIZATION,
  UPDATE_ORGANIZATION,
  UPDATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION,
  GET_INVOICES,
  ADD_INVOICE,
  REMOVE_ORGANIZATION,
  CANCEL_REMOVE_ORGANIZATION,
  GET_SUBSCRIPTION_PLAN_FEATURE,
  SET_ACCOUNT_VERIFIED,
  BLOCK_ACCOUNT,
  UNBLOCK_ACCOUNT,
  MARK_INVOICE_AS_PAID,
  RESET_ACCOUNT_QUOTA_USAGE
} from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'organizations',
  components: {
    DefaultLayout
  },
  data() {
    return {
      addDialogAccount: false,
      rules: [(value) => !!value || 'Required.'],
      editable: false,
      editableLoading: false,
      editableSubscription: false,
      editableSubscriptionLoading: false,
      menu: false,
      dialogAccount: false,
      addInvoiceDialog: false,
      deleteAccountDialog: false,
      invoicesDialog: false,
      dataLoading: false,
      accountsHeaders: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Email', value: 'email', align: 'left' },
        { text: 'Admin email', value: 'adminEmail', align: 'left' },
        { text: 'Admin name', value: 'adminFirstName', align: 'left' },
        { text: 'Tenant Funnel', value: 'isTenantfunnel', align: 'center' },
        { text: 'AI Enabled', value: 'isAIEnabled', align: 'center' },
        { text: 'Created', value: 'dateCreated', align: 'left' },
        { text: 'Updated', value: 'dateUpdated', align: 'left' },
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Verified', value: 'verified', align: 'left' },
        { text: 'Deletion', value: 'deletion', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false }
      ],
      search: '',
      isEdit: false,
      id: '',
      name: '',
      nameRepeat: '',
      email: '',
      adminFName: '',
      adminLName: '',
      adminEmail: '',
      modalTitle: 'Add New Account',
      organizations: [],
      isTenantFunnel: false,
      isAIEnabled: false,
      invoiceUnits: null,
      selectedInvoices: null,
      accountDetails: null,
      billingPeriod: [
        { text: 'None', value: 0 },
        { text: 'Manual', value: 1 },
        { text: 'Monthly', value: 2 },
        { text: 'Yearly', value: 3 }
      ],
      billingPeriodSelected: 0,
      invoiceType: [
        { text: 'None', value: 0 },
        { text: 'Manual', value: 1 },
        { text: 'Stripe', value: 2 }
      ],
      invoiceTypeSelected: 0,
      invoiceIssueType: [
        { text: 'None', value: 0 },
        { text: 'Manual', value: 1 },
        { text: 'Auto', value: 2 }
      ],
      invoiceIssueTypeSelected: 0,
      subscriptionPlans: [],
      subscriptionPlansSelected: '',
      invoiceIssueAfterDays: 0,
      featureLists: null,
      selectedAccounts: []
    };
  },
  computed: {
    preparedOrganizations() {
      const prepared = this.organizations.map((org) => {
        return {
          ...org
        };
      });
      return prepared;
    }
  },
  methods: {
    async addNewAccount() {
      if (this.$refs.accountAddForm.validate()) {
        if (this.subscriptionPlansSelected === '00000000-0000-0000-0000-000000000000') {
          this.$notify({
            type: 'error',
            title: '!!!',
            text: 'Subscription plan not selected!'
          });
          return;
        }
        if (this.billingPeriodSelected === 0) {
          this.$notify({
            type: 'error',
            title: '!!!',
            text: 'Billing period not selected!'
          });
          return;
        }
        if (this.invoiceIssueTypeSelected === 0) {
          this.$notify({
            type: 'error',
            title: '!!!',
            text: 'Invoice issue type not selected!'
          });
          return;
        }
        if (this.invoiceTypeSelected === 0) {
          this.$notify({
            type: 'error',
            title: '!!!',
            text: 'Invoice type not selected!'
          });
          return;
        }

        var today = new Date();
        var tomorrow = new Date();
        tomorrow.setDate(today.getDate() + parseInt(this.invoiceIssueAfterDays));

        let account = {
          id: this.id,
          name: this.name,
          email: this.email,
          adminEmail: this.adminEmail,
          adminFirstName: this.adminFName,
          adminLastName: this.adminLName,
          subscriptionPlanId: this.subscriptionPlansSelected,
          billingPeriod: this.billingPeriodSelected,
          invoiceType: this.invoiceTypeSelected,
          invoiceIssueType: this.invoiceIssueTypeSelected,
          nextInvoiceIssueDate: tomorrow
        };

        try {
          await this.$store.dispatch(ADD_ORGANIZATION, account);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Account added'
          });
          this.updateOrganizations();
        } catch (err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error adding new account. Please contact support@planetverify.com'
          });
        }

        this.addDialogAccount = false;
      }
    },
    async resetUsage(f) {
      if (confirm('Reset usage?')) {
        await this.$store.dispatch(RESET_ACCOUNT_QUOTA_USAGE, {
          quota: f.feature,
          accountId: this.accountDetails.account.id
        });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Quota usage updated!'
        });
      }
    },
    async markInvoiceAsPaid(invoice) {
      if (confirm('Mark invoice as paid?')) {
        await this.$store.dispatch(MARK_INVOICE_AS_PAID, { invoiceId: invoice.id });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Invoice status updated!'
        });
      }
    },
    async setVerified() {
      if (confirm('Set accounts as verified?')) {
        let accounts = [];
        this.selectedAccounts.forEach((el) => {
          accounts.push(el.id);
        });
        var verification = {
          accountIds: accounts,
          verified: true
        };
        try {
          await this.$store.dispatch(SET_ACCOUNT_VERIFIED, verification);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Account updated'
          });
          this.updateOrganizations();
        } catch (err) {
          this.$notify({
            type: 'error',
            title: 'Error!',
            text: 'Error updating account. Please contact support@planetverify.com'
          });
        }
      }
    },
    getLimitName(id) {
      if (id === 0) {
        return 0;
      }
      return this.featureLists.featureQuota.find((_) => _.type === id).name;
    },
    getFeatureName(id) {
      if (id === 0) {
        return 0;
      }
      return this.featureLists.feature.find((_) => _.type === id).name;
    },
    itemRowBackground(item) {
      if (item.deletion) {
        return 'rowred';
      }
      if (item.status === 0) {
        return 'rownone';
      }
      if (item.status === 1) {
        return 'rowblue';
      }
      if (item.status === 2) {
        return 'roworange';
      }
      if (item.status === 3) {
        return 'rowgreen';
      }
      if (item.status === 4) {
        return 'rowred';
      }

      return 'rowgreen';
    },
    async updateSubscription() {
      if (this.subscriptionPlansSelected === '00000000-0000-0000-0000-000000000000') {
        this.$notify({
          type: 'error',
          title: '!!!',
          text: 'Subscription plan not selected!'
        });
        return;
      }
      if (this.billingPeriodSelected === 0) {
        this.$notify({
          type: 'error',
          title: '!!!',
          text: 'Billing period not selected!'
        });
        return;
      }
      if (this.invoiceIssueTypeSelected === 0) {
        this.$notify({
          type: 'error',
          title: '!!!',
          text: 'Invoice issue type not selected!'
        });
        return;
      }
      if (this.invoiceTypeSelected === 0) {
        this.$notify({
          type: 'error',
          title: '!!!',
          text: 'Invoice type not selected!'
        });
        return;
      }
      var subscription = {
        accountId: this.id,
        subscriptionPlanId: this.subscriptionPlansSelected,
        billingPeriod: this.billingPeriodSelected,
        invoiceType: this.invoiceTypeSelected,
        invoiceIssueType: this.invoiceIssueTypeSelected,
        invoiceIssueAfterDays: this.invoiceIssueAfterDays
      };
      this.editableSubscriptionLoading = true;
      this.editableSubscription = false;
      try {
        if (
          this.accountDetails.subscription.subscriptionPlanId ===
          '00000000-0000-0000-0000-000000000000'
        ) {
          await this.$store.dispatch(CREATE_SUBSCRIPTION, subscription);
        } else {
          await this.$store.dispatch(UPDATE_SUBSCRIPTION, subscription);
        }
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Subscription for account updated. Wait some time and refresh the account details to see updated data.'
        });
        this.updateOrganizations();
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error updating account. Please contact support@planetverify.com'
        });
      }
      this.editableSubscriptionLoading = false;
    },
    async saveAccountSetting() {
      if (this.$refs.accountForm.validate()) {
        var organization = {
          id: this.id,
          name: this.name,
          email: this.email,
          adminEmail: this.adminEmail,
          adminFirstName: this.adminFName,
          adminLastName: this.adminLName,
          isTenantFunnel: this.isTenantFunnel,
          isAIEnabled: this.isAIEnabled
        };
        this.editableLoading = true;
        this.editable = false;
        try {
          await this.$store.dispatch(UPDATE_ORGANIZATION, organization);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Account updated'
          });
          this.updateOrganizations();
        } catch (err) {
          this.$notify({
            type: 'error',
            title: 'Error!',
            text: 'Error updating account. Please contact support@planetverify.com'
          });
        }
      }
      this.editableLoading = false;
    },
    getBillingPeriodString() {},
    getRowColor(date) {
      if (new Date(date) > Date.now()) {
        return 'rowgreen';
      }
      return 'rowred';
    },
    formatDate(date) {
      return new Date(date).toLocaleString('en-GB', { timeZone: 'UTC' });
    },
    async updateOrganizations() {
      this.dataLoading = true;
      try {
        const response = await this.$store.dispatch(GET_ORGANIZATIONS);
        this.organizations = response;
        this.totalRows = response.length;
        this.dataLoading = false;
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting organizations. Please contact support@planetverify.com'
        });
        this.dataLoading = false;
      }
    },
    addOrganization() {
      // this.isEdit = false;
      // this.modalTitle = 'Add New Account';
      this.id = uuidv4();
      this.name = '';
      this.email = '';
      this.adminFName = '';
      this.adminLName = '';
      this.adminEmail = '';
      this.addDialogAccount = true;
    },
    async editOrg(org) {
      this.isEdit = true;
      this.modalTitle = 'Update Account';
      this.id = org.id;
      this.name = org.name;
      this.email = org.email;
      this.adminFName = org.adminFirstName;
      this.adminLName = org.adminLastName;
      this.adminEmail = org.adminEmail;
      this.accountDetails = await this.$store.dispatch(GET_ACCOUNT_DETAILS, org.id);
      this.billingPeriodSelected = this.accountDetails.subscription.billingPeriod;
      this.subscriptionPlansSelected = this.accountDetails.subscription.subscriptionPlanId;
      this.invoiceTypeSelected = this.accountDetails.subscription.invoiceType;
      this.invoiceIssueTypeSelected = this.accountDetails.subscription.invoiceIssueType;

      let invoices = await this.$store.dispatch(GET_INVOICES, org.id);
      this.selectedInvoices = [];
      if (invoices.list) {
        invoices.list.forEach((el) => {
          if (el.status != 0) {
            this.selectedInvoices.push(el);
          }
        });
      }
      this.dialogAccount = true;
    },
    async saveOrganization() {
      if (this.$refs.accountForm.validate()) {
        var organization = {
          id: this.id,
          name: this.name,
          email: this.email,
          adminEmail: this.adminEmail,
          adminFirstName: this.adminFName,
          adminLastName: this.adminLName,
          csvExport: this.csv,
          verificationService: this.verificationServ,
          requestScheduller: this.reqSched,
          anonymousRequests: this.anonReq,
          quickLinks: this.quickLinks,
          purgedRequests: this.purgedRequests,
          credits: this.credits,
          discount: this.discount,
          dateTrialExpire: this.trialDate,
          dateDiscountExpire: this.discountDate,
          dateCreditsExpire: this.creditsDate,
          requestsQuoteLimit: this.requestQuote,
          maxAllowedAccounts: this.maxAccounts,
          maxUsersPerAccount: this.maxUsers
        };
        if (this.isEdit) {
          // EDIT ACCOUNT
          try {
            await this.$store.dispatch(UPDATE_ORGANIZATION, organization);
            this.$notify({
              type: 'success',
              title: 'Success',
              text: 'Account updated'
            });
            this.updateOrganizations();
          } catch (err) {
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Error updating account. Please contact support@planetverify.com'
            });
          }
        } else {
          // ADD NEW ACCOUNT
          try {
            await this.$store.dispatch(ADD_ORGANIZATION, organization);
            this.$notify({
              type: 'success',
              title: 'Success',
              text: 'Account added'
            });
            this.updateOrganizations();
          } catch (err) {
            this.$notify({
              type: 'error',
              title: 'Error',
              text: 'Error adding new account. Please contact support@planetverify.com'
            });
          }
        }
        this.dialogAccount = false;
      }
    },
    async invoiceHistory(org) {
      try {
        const response = await this.$store.dispatch(GET_INVOICES, org.id);
        this.selectedInvoices = response.map((invoice) => {
          const splitDateCreated = invoice.dateCreated.split(' ');
          const splitDateUpdated = invoice.dateUpdated.split(' ');
          const splitCreated = splitDateCreated[0].split('/');
          const splitUpdated = splitDateUpdated[0].split('/');
          const formattedDateCreated = `${splitCreated[1]}/${splitCreated[0]}/${splitCreated[2]}`;
          const formattedDateUpdated = `${splitUpdated[1]}/${splitUpdated[0]}/${splitUpdated[2]}`;
          return {
            ...invoice,
            formattedCreated: `${formattedDateCreated} ${splitDateCreated[1]}`,
            formattedUpdated: `${formattedDateUpdated} ${splitDateUpdated[1]}`
          };
        });
        this.invoicesDialog = true;
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting invoice history. Please contact support@planetverify.com'
        });
      }
    },
    addInvoice(org) {
      this.id = org.id;
      this.invoiceUnits = null;
      this.invoiceDateExpire = new Date(
        new Date(org.subscription.dateCreditsExpire).toString().split('GMT')[0] + ' UTC'
      )
        .toISOString()
        .split('T')[0];
      this.addInvoiceDialog = true;
    },
    deleteAccount(org) {
      this.id = org.id;
      this.name = org.name;
      this.nameRepeat = '';
      this.deleteAccountDialog = true;
    },
    async calcelDeleteAccount(id) {
      if (!confirm('Cancel delete account and all related data?')) {
        return;
      }
      await this.$store.dispatch(CANCEL_REMOVE_ORGANIZATION, { organizationId: id });
      this.$notify({
        type: 'success',
        title: 'Success',
        text: 'Account deletion canceled!'
      });
    },
    async deleteAccount(id) {
      if (!confirm('Delete account and all related data?')) {
        return;
      }
      await this.$store.dispatch(REMOVE_ORGANIZATION, { organizationId: id });
      this.$notify({
        type: 'success',
        title: 'Success',
        text: 'Account deletion started!'
      });
    },
    async blockAccount(id) {
      if (!confirm('Block account?')) {
        return;
      }
      await this.$store.dispatch(BLOCK_ACCOUNT, { accountId: id });
      this.$notify({
        type: 'success',
        title: 'Success',
        text: 'Account blocked!'
      });
    },
    async unblockAccount(id) {
      if (!confirm('Unblock account?')) {
        return;
      }
      await this.$store.dispatch(UNBLOCK_ACCOUNT, { accountId: id });
      this.$notify({
        type: 'success',
        title: 'Success',
        text: 'Account unblocked!'
      });
    },
    async createInvoice() {
      if (!confirm('Add new invoice?')) {
        return;
      }
      var invoice = {
        subscriptionId: this.accountDetails.subscription.id
      };
      try {
        await this.$store.dispatch(ADD_INVOICE, invoice);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Invoice added'
        });
        this.updateOrganizations();
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Something went wrong - please contact support@planetverify.com'
        });
      }
    },
    async getSubscriptionPlans() {
      const response = await this.$store.dispatch(GET_SUBSCRIPTION_PLANS);
      response.list.push({
        annualPayDiscountPercentage: 5,
        dateCreated: '2022-09-13T08:15:51.26',
        dateUpdated: '2022-09-13T08:58:13.409',
        daysTrialPeriod: 15,
        featureQuotas: Array(6),
        features: Array(43),
        id: '00000000-0000-0000-0000-000000000000',
        name: 'Not selected',
        pricePerMonth: 25,
        privatePlan: false
      });
      this.subscriptionPlans = response.list;
    },
    async getSubscriptionPlanFeature() {
      this.featureLists = await this.$store.dispatch(GET_SUBSCRIPTION_PLAN_FEATURE);
    }
  },
  async mounted() {
    await this.updateOrganizations();
    await this.getSubscriptionPlans();
    await this.getSubscriptionPlanFeature();
  }
};
</script>

<style>
.rownone {
  background-color: #fff;
}
.rowblue {
  background-color: #d3f5ff;
}
.roworange {
  background-color: #ffefd3;
}
.rowgreen {
  background-color: #deffe4;
}
.rowred {
  background-color: #ffdcdc;
}
.account-form__checkbox-text {
  width: 100px;
  font-size: 14px;
  line-height: 1.2;
}
</style>
